import {
    Container,
    SimpleGrid,
    Box,
    Text,
    Button,
    HStack,
    Image,
    Flex,
    InputGroup,
    InputLeftElement,
    Divider,
    Input,
    VStack
} from '@chakra-ui/react'

import React, { useRef, useState, } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { IoChevronDown, IoSearchOutline } from "react-icons/io5";
import { IoMdArrowBack } from "react-icons/io";
import { useAuth } from '../../providers/AuthProvider';
import { useCollections } from '../../providers/CollectionsProvider';
import { useCategories } from '../../providers/CategoriesProvider';
import { useCarts } from '../../providers/CartProvider';

export default function MobileNav({ onClose }) {

    const { loading: collectionsLoading, collectionsForHomePage } = useCollections();
    const { loading: categoriesLoading, categories } = useCategories();

    const [viewShop, setviewShop] = useState(false)
    const [viewCollections, setviewCollections] = useState(false)
    const [viewCategory, setviewCategory] = useState(false)
    const [viewAccessories, setviewAccessories] = useState(false)
    const { logged, logout } = useAuth()
    const [viewprofile, setviewProfile] = useState(false)

    const { carts } = useCarts();

    const searchRef = useRef(null);
    const navigate = useNavigate();

    if (collectionsLoading || categoriesLoading) return null;

    return (
        <Container
            transition={'all ease-in 300ms'}
            h={'100vh'}
            w={'100%'}
            position='fixed'
            overflowY={'auto'}
            bg={'white'}
        >
            <Box h='100%' w={'100%'} position={'relative'}>
                <SimpleGrid columns={[1, 1, 1, 1]} spacing='4'>
                    <Box />
                    <HStack spacing='4'>
                        {/* <GrUndo size={28} onClick={() => // props.setopenMenu(false)
                        onClose()} /> */}
                        {/* <IoMdArrowBack size={28} onClick={() => // props.setopenMenu(false)
                        onClose()} /> */}
                        <IoMdArrowBack size={28} onClick={() => onClose()} />
                        <img src='/logo-dark.png' alt='' width='120px' />
                    </HStack>
                    {/* <GrUndo size={20} onClick={() => // props.setopenMenu(false)
                    onClose()} /> */}
                    {/* <IoSearchOutline size={20} /> */}

                    <HStack>
                        <InputGroup autoFocus='false'>
                            <InputLeftElement pointerEvents='none'  >
                                <IoSearchOutline size={18} />
                            </InputLeftElement>
                            <Input
                                ref={searchRef}
                                autoFocus={false}
                                variant='outline'
                                outline='none'
                                border='none'
                                borderBottom='1px solid #E5E5E5'
                                placeholder='Search'
                                onSubmit={() => {
                                    console.log('submit')
                                }}
                            />
                        </InputGroup>

                        <Button variant='outline' borderRadius='lg' color={'black'} fontSize={'lg'}
                            onClick={() => {
                                console.log('submit')
                                onClose();
                                navigate(`/products-search`, { state: { search: searchRef.current.value } });
                            }}
                        >
                            Search
                        </Button>
                    </HStack>
                    <Link
                        to={`/`}
                        onClick={() => // props.setopenMenu(false)
                            onClose()
                        }
                    >
                        <Button
                            variant='ghost'
                            borderRadius='lg'
                            color={'black'}
                            fontSize={'lg'}
                            my={2}
                            w={'100%'}
                            rounded={0}
                            justifyContent={'flex-start'}
                        // borderBottom={'1px solid #E5E5E5'}
                        >
                            Home
                        </Button>
                    </Link>
                    <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                        my={2}
                        w={'100%'}
                        rounded={0}
                        justifyContent={'flex-start'}
                        // borderBottom={'1px solid #E5E5E5'}
                        onClick={() => {
                            setviewShop(!viewShop)
                            setviewCollections(false)
                            setviewCategory(false)
                            setviewAccessories(false)
                        }}
                    >
                        <HStack w='100%' justifyContent='space-between' alignItems='center'>
                            <Text fontSize={'lg'}>Shop</Text>
                            <IoChevronDown />
                        </HStack>
                    </Button>
                    {viewShop ?
                        <VStack
                            pl={6}
                            w={'100%'}
                        >
                            <Button
                                variant='ghost'
                                borderRadius='lg'
                                color={'black'}
                                fontSize={'lg'}
                                my={2}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                                // borderBottom={'1px solid #E5E5E5'}
                                onClick={() => {
                                    setviewCollections(!viewCollections)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                }}
                            >
                                <HStack w='100%' justifyContent='space-between' alignItems='center'>
                                    <Text fontSize={'lg'}>Collections</Text>
                                    <IoChevronDown />
                                </HStack>
                            </Button>
                            {
                                viewCollections ?
                                    <VStack
                                        pl={8}
                                        w={'100%'}
                                    >
                                        {collectionsForHomePage.map((col, index) => {
                                            return <Box
                                                onClick={() => {
                                                    onClose()
                                                    setviewCollections(false)
                                                    setviewShop(false)
                                                    setviewCategory(false)
                                                    setviewAccessories(false)
                                                }}
                                                as={Link}
                                                to={`/collections/${col.slug}`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                                my={2}
                                                py={2}
                                                pl={3}
                                                w={'100%'}
                                                rounded={0}
                                                justifyContent={'flex-start'}
                                            >
                                                {col.name}
                                            </Box>
                                        })}
                                    </VStack> : null
                            }
                            <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                                onClick={() => {
                                    setviewCollections(false)
                                    setviewCategory(!viewCategory)
                                    setviewAccessories(false)
                                }}
                            >
                                <HStack w='100%' justifyContent='space-between' alignItems='center'>
                                    <Text fontSize={'lg'}>Categories</Text>
                                    <IoChevronDown />
                                </HStack>
                            </Button>
                            {
                                viewCategory ? <VStack pl={8} w={'100%'} justifyContent={'center'} alignItems={'flex-start'}>

                                    {categories.map((cat, index) => {
                                        return <Box
                                            onClick={() => {
                                                onClose()
                                                setviewCollections(false)
                                                setviewShop(false)
                                                setviewCategory(false)
                                                setviewAccessories(false)
                                            }}
                                            as={Link}
                                            to={`/categories/${cat.slug}`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                            my={2}
                                            py={2}
                                            pl={3}
                                            w={'100%'}
                                            rounded={0}
                                            justifyContent={'flex-start'}
                                        >
                                            {cat.name}
                                        </Box>
                                    })}

                                </VStack> : null
                            }
                            <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                                // borderBottom={'1px solid #E5E5E5'}
                                onClick={() => {
                                    setviewCollections(false)
                                    setviewCategory(false)
                                    setviewAccessories(!viewAccessories)
                                }}
                            >

                                <HStack w='100%' justifyContent='space-between' alignItems='center'>
                                    <Text fontSize={'lg'}>Accesories</Text>
                                    <IoChevronDown />
                                </HStack>
                            </Button>
                            {
                                viewAccessories ? <VStack pl={8} w={'100%'}>
                                    <Box
                                        onClick={() => {
                                            // props.setopenMenu(false)
                                            onClose()
                                            setviewCollections(false)
                                            setviewShop(false)
                                            setviewCategory(false)
                                            setviewAccessories(false)
                                        }}
                                        as={Link}
                                        to={`/`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                        my={2}
                                        py={2}
                                        pl={3}
                                        w={'100%'}
                                        rounded={0}
                                        justifyContent={'flex-start'}
                                    >
                                        Shoes
                                    </Box>
                                </VStack> : null
                            }
                        </VStack> : null}


                    <Link to={`/about`} onClick={() =>
                        onClose()} >
                        <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                            my={2}
                            w={'100%'}
                            rounded={0}
                            justifyContent={'flex-start'}
                        >
                            About Us
                        </Button>
                    </Link>

                    <Link to={`/contact`} onClick={() =>
                        onClose()} >
                        <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                            my={2}
                            w={'100%'}
                            rounded={0}
                            justifyContent={'flex-start'}
                            alignItems={'center'}
                        >
                            Contact Us
                        </Button>
                    </Link>

                    <Divider w='90%' />

                    <Link to={`/cart`} onClick={() =>
                        onClose()} >
                        <Button variant='ghost' borderRadius='lg' color={'black'}
                            my={2}
                            w={'100%'}
                            rounded={0}
                            justifyContent={'space-between'}
                            alignItems={'center'}

                        >
                            <Text fontSize={'lg'}>Shopping Cart</Text>
                            <HStack
                                ml={5}
                                gap={1}
                                justifyContent='flex-end' alignItems={'center'}>

                                <img src='/shop-bag.png' width='20' />
                                <Flex
                                    borderRadius={'50%'}
                                    bg={'black'}
                                    color={'white'}
                                    w={'18px'}
                                    h={'18px'}
                                    justifyContent={'center'}
                                    alignItems='center'
                                    fontSize={'12px'}
                                >
                                    {carts.length}
                                </Flex>
                            </HStack>
                        </Button>
                    </Link>
                    <Link to={`/wishlist`} onClick={() =>
                        onClose()} >
                        <Button variant='ghost' borderRadius='lg' color={'black'}
                            my={2}
                            w={'100%'}
                            rounded={0}
                            justifyContent={'space-between'}
                            alignItems={'center'}

                        >
                            <Text fontSize={'lg'}>Wishlist</Text>
                            {/* <HStack
                                ml={5}
                                gap={1}
                                justifyContent='flex-end' alignItems={'center'}>
                                <img src='/shop-bag.png' width='20' />
                                <Flex
                                    borderRadius={'50%'}
                                    bg={'black'}
                                    color={'white'}
                                    w={'18px'}
                                    h={'18px'}
                                    justifyContent={'center'}
                                    alignItems='center'
                                    fontSize={'12px'}
                                >
                                    0
                                </Flex>
                            </HStack> */}
                        </Button>
                    </Link>
                    <Divider w='90%' />
                    {
                        logged ?
                            <Button
                                variant='ghost'
                                borderRadius='lg'
                                color={'black'}
                                fontSize={'lg'}
                                my={2}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                                onClick={() => {
                                    setviewProfile(!viewprofile)
                                    setviewCollections(false)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                }}
                            >

                                <HStack w='100%' justifyContent='space-between' alignItems='center'>
                                    <Text fontSize={'lg'}>My Account</Text>
                                    <IoChevronDown />
                                </HStack>
                            </Button>

                            :
                            <Link to={`/login`} onClick={() =>
                                onClose()} >
                                <Button variant='ghost' borderRadius='lg' color={'black'} fontSize={'lg'}
                                    my={2}
                                    w={'100%'}
                                    rounded={0}
                                    justifyContent={'flex-start'}
                                >
                                    Sign In
                                </Button>
                            </Link>
                    }
                    {
                        viewprofile && <VStack pl={8} w={'100%'}>
                            <Box
                                onClick={() => {
                                    onClose()
                                    setviewCollections(false)
                                    setviewShop(false)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                    setviewProfile(false)
                                }}
                                as={Link}
                                to={`/profile`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                py={2}
                                pl={3}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                            >
                                My Profile
                            </Box>
                            <Box
                                onClick={() => {
                                    onClose()
                                    setviewCollections(false)
                                    setviewShop(false)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                    setviewProfile(false)
                                }}
                                as={Link}
                                to={`/wishlist`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                py={2}
                                pl={3}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                            >
                                Wishlist
                            </Box>
                            <Box
                                onClick={() => {
                                    onClose()
                                    setviewCollections(false)
                                    setviewShop(false)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                    setviewProfile(false)
                                    setviewProfile(false)
                                }}
                                as={Link}
                                to={`/orders`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                py={2}
                                pl={3}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                            >
                                My Orders
                            </Box>
                            <Box
                                onClick={() => {
                                    onClose()
                                    setviewCollections(false)
                                    setviewShop(false)
                                    setviewCategory(false)
                                    setviewAccessories(false)
                                    setviewProfile(false)
                                    logout()
                                }}
                                as={Link}
                                to={`/`} borderRadius='lg' color={'black'} fontSize={'lg'}
                                my={2}
                                py={2}
                                pl={3}
                                w={'100%'}
                                rounded={0}
                                justifyContent={'flex-start'}
                            >
                                Logout
                            </Box>
                        </VStack>
                    }

                    <HStack mt='4' pb={5}>
                        <Image src='/facebook.png' alt='' />
                        <Image src='/instagram.png' alt='' />
                    </HStack>
                </SimpleGrid>
            </Box>
        </Container>
    )
}
